export const sum_portfolioLastUpdate = `query sum_portfolio{
    sum_portfolio{
        last_update
    }
}`;
